import { Field, ErrorMessage } from 'formik';
import Cleave from 'cleave.js/react';
import { FormGroup, Label, FormFeedback } from 'reactstrap';
import React from 'react';

interface Props {
   name: string;
   label?: string;
   placeholder?: string;
   className?: string;
   type?: 'credit-card' | 'bank-account';
}

export const FormikNumberInput: React.FC<Props> = ({
   name,
   label,
   placeholder = '**** **** **** ****',
   className = '',
   type = 'credit-card',
}) => {
   const getCleaveOptions = () => {
      if (type === 'credit-card') {
         return { creditCard: true };
      }
      return {
         numericOnly: true,
         blocks: [4, 4, 4, 4],
         delimiter: ' ',
      };
   };

   return (
      <FormGroup className="mb-3">
         {label && (
            <Label
               for={name}
               style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
            >
               {label}
            </Label>
         )}

         <Field name={name}>
            {({ field, meta, form }: { field: any; meta: any; form: any }) => (
               <>
                  <Cleave
                     {...field}
                     id={name}
                     className={`form-control ${className} ${
                        meta.touched && meta.error ? 'is-invalid' : ''
                     }`}
                     options={getCleaveOptions()}
                     placeholder={placeholder}
                     onChange={(e) => {
                        const numericValue = e.target.rawValue.replace(
                           /\D/g,
                           ''
                        );
                        form.setFieldValue(name, numericValue);
                     }}
                     autoComplete="off"
                  />
                  <FormFeedback>
                     <ErrorMessage name={name} />
                  </FormFeedback>
               </>
            )}
         </Field>
      </FormGroup>
   );
};
